
import { tedMediaArray } from './tedMedia'
import { robinReviewerProfile, sluttyPumpkinReviewerProfile, stellaReviewerProfile, tracyReviewerProfile, victoriaReviewerProfile, zoeyReviewerProfile } from './tedReviewers'
import { tedBio, robinBio, sluttyPumpkinBio, stellaBio, tracyBio, victoriaBio, zoeyBio } from './tedBios'
import { tedDatingProfileHinge, tedDatingProfileBumble, tedDatingProfileTinder } from './tedDatingProfiles'

export const tedUser = {
  _id: 'tedUserId',
  email: 'ted@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: false,
  reviewerProfilesToSelectFrom: [
    { ...robinReviewerProfile },
    { ...sluttyPumpkinReviewerProfile },
    { ...stellaReviewerProfile },
    { ...tracyReviewerProfile },
    { ...victoriaReviewerProfile },
    { ...zoeyReviewerProfile }
  ],
  media: [ ...tedMediaArray ],
  bio: { ...tedBio },
  datingProfiles: [
    { ...tedDatingProfileHinge },
    { ...tedDatingProfileBumble },
    { ...tedDatingProfileTinder }
  ],
  reviewerProfile: {},
}

export const robinUser = {
  _id: 'robinUserId',
  email: 'robin@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...robinBio },
  datingProfiles: [],
  reviewerProfile: { ...robinReviewerProfile },
}

export const sluttyPumpkinUser = {
  _id: 'sluttyPumpkinUserId',
  email: 'sluttypumpkin@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...sluttyPumpkinBio },
  datingProfiles: [],
  reviewerProfile: { ...sluttyPumpkinReviewerProfile },
}

export const stellaUser = {
  _id: 'stellaUserId',
  email: 'stella@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...stellaBio },
  datingProfiles: [],
  reviewerProfile: { ...stellaReviewerProfile },
}

export const tracyUser = {
  _id: 'tracyUserId',
  email: 'tracy@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...tracyBio },
  datingProfiles: [],
  reviewerProfile: { ...tracyReviewerProfile },
}

export const victoriaUser = {
  _id: 'victoriaUserId',
  email: 'victoria@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...victoriaBio },
  datingProfiles: [],
  reviewerProfile: { ...victoriaReviewerProfile },
}

export const zoeyUser = {
  _id: 'zoeyUserId',
  email: 'zoey@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...zoeyBio },
  datingProfiles: [],
  reviewerProfile: { ...zoeyReviewerProfile },
}